export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8778.298da884.jpg";